module.exports = __webpack_public_path__ + "static/media/Avatars_Male-14.4162d062.png";